//Material table makes the alignment of some columns to the right highly suboptimal.
//We need to make sure it doesn't bring problems in large designs
//Meaning that, in our case, the um of columns + action sizes should be at least 1200

export const MARKETERS_TABLE_COLUMNS = [
  {
    field: 'nombre',
    align: 'left',
    width: 250,
  },
  {
    field: 'direccion',
    align: 'left',
    width: 250,
  },
  {
    field: 'telefono',
    align: 'left',
    width: 180,
  },
  {
    field: 'email',
    align: 'left',
    width: 250,
  },
]

export const MARKETERS_TABLE_ACTIONS = [
  {
    field: 'active',
    width: 130,
    align: 'center',
    sorting: false,
  },
  {
    field: 'actions',
    width: 130,
    align: 'center',
    sorting: false,
  },
]
